<template>
  <div class="profile">
    <div class="profile-fixed">
      <router-link v-for="(item, index) in tabs" :key="index" class="profile-tabs-item" tag="div" :to="item.path">{{ item.title }}</router-link>
    </div>
    <div class="profile-content">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      tabs: [
        {
          path: { name: 'center' },
          title: '个人中心'
        },
        {
          path: { name: 'collection' },
          title: '我的收藏'
        },
        {
          path: { name: 'bids' },
          title: '我的投标'
        },
        {
          path: { name: 'invitation' },
          title: '我的邀约'
        },
        {
          path: { name: 'message' },
          title: '我的消息'
        },
        {
          path: { name: 'info' },
          title: '企业信息管理'
        },
        {
          path: { name: 'projects' },
          title: '项目经验管理'
        }
      ]
    }
  },

  methods: {
    ...mapActions([
      'uploadUserInfo'
    ])
  },

  created() {
    this.uploadUserInfo()
  }
}
</script>

<style lang="scss" scoped>
.profile {
    position: relative;
    display: flex;
    align-items: flex-start;
    padding: 10px 0 100px;
    max-width: 1200px;
    margin: 0 auto;
    .profile-fixed {
        flex: 1;
        max-width: 336px;
        padding: 30px 0;
        background-color: #fff;
        border-radius: 4px;
        margin: 0 20px 0 0;
        vertical-align: top;
        .profile-tabs-item {
            font-size: 16px;
            padding: 0 30px;
            cursor: pointer;
            &:nth-child(n + 2) {
                margin: 34px 0 0;
            }
        }
        .router-link-active {
            color: #417ef7;
        }
    }
    .profile-content {
        flex: 2;
        min-height: 770px;
        background-color: #fff;
        border-radius: 4px;
        vertical-align: top;
    }
}
/deep/ .el-card {
    border: 0;
    .el-card__header {
        display: flex;
        align-items: center;
        height: 80px;
        padding: 0 30px;
        border-color: #F0F0F0;
        .el-card__left {
            flex: 1;
            font-size: 26px;
            font-weight: bold;
        }
        .el-button {
            flex-shrink: 0;
            width: 126px;
            height: 40px;
            line-height: 38px;
            font-size: 16px;
            padding: 0;
        }
    }
    .el-card__body {
        padding: 30px;
    }
}
</style>
